import { createFeatureSelector } from '@ngrx/store';

import {
  ModalControlsSaveable,
  ModalControlsSaveableFactory,
} from '®shared/modals';

export const STATE_FEATURE_LIST_DETAILS_EDITOR = 'listDetailsEditor';

export interface ListDetailsEditorState {
  modalControl: ModalControlsSaveable;
}

export const LIST_DETAILS_EDITOR_INITIAL_STATE: ListDetailsEditorState = {
  modalControl: ModalControlsSaveableFactory.hide(),
};

export function getInitialListDetailsEditorState(): ListDetailsEditorState {
  return LIST_DETAILS_EDITOR_INITIAL_STATE;
}

export const selectListDetailsEditorState =
  createFeatureSelector<ListDetailsEditorState>(
    STATE_FEATURE_LIST_DETAILS_EDITOR,
  );
